<template>
  <div class="main_container">
    <NavBar />
    <div class="main_home">
      <section>
        <div class="main_section cookie">
          <h3 class="main_section-title">Cookie Policy</h3>
          <div class="questions_content">
            <p class="main_section-sub">Effective Date: October 24, 2025</p>
            <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
              <div class="tab_block">
<!--                <h4 class="tab_block-name">How We Use Your Information</h4>-->
                <div class="tab_block-description">ShonCompany.com uses cookies to improve your browsing experience:
                  <ul>
                    <li>What Are Cookies? Small text files are stored on your device when you visit our site.</li>
                    <li>Types Used:</li>
                    <li>Essential cookies (site functionality)</li>
                    <li>Analytics cookies (to understand usage and improve performance)</li>
                    <li>Preference cookies (to remember your settings)</li>
                    <li>Managing Cookies: You can turn off cookies in your browser settings, but some features may not work correctly.</li>
                    <li>Consent: By continuing to use the site, you consent to our use of cookies.</li>
                  </ul>
                </div>
              </div>

<!--              <div class="tab_block">-->
<!--                <h4 class="tab_block-name">Your Rights & Choices</h4>-->
<!--                <div class="tab_block-description">Where applicable (e.g., GDPR, CCPA/CPRA), you have the right to:-->
<!--                  <ul>-->
<!--                    <li>Access, correct, or delete personal information</li>-->
<!--                    <li>Withdraw consent at any time</li>-->
<!--                    <li>Opt out of marketing communications</li>-->
<!--                    <li>Object to or restrict certain processing activities</li>-->
<!--                  </ul>-->
<!--                  To exercise these rights, contact us at privacy@shoncompany.com.-->
<!--                </div>-->
<!--                <h4 class="tab_block-name">Data Security & Retention</h4>-->
<!--                <p class="tab_block-description">We implement industry-standard security measures (e.g., encryption,-->
<!--                  access controls) to protect your data. Your information is retained as long as necessary to fulfill-->
<!--                  its original purpose, comply with legal obligations, resolve disputes, and enforce agreements..</p>-->
<!--                <h4 class="tab_block-name">Children’s Privacy</h4>-->
<!--                <p class="tab_block-description">Our Site is not intended for individuals under age 16. We do not-->
<!--                  knowingly collect personal data from minors. If we learn we have collected such information without-->
<!--                  parental consent, we will take steps to delete it promptly.</p>-->
<!--                <h4 class="tab_block-name">International Data Transfers</h4>-->
<!--                <p class="tab_block-description">If you are outside the U.S., your data may be transferred to and-->
<!--                  processed in the U.S. or other countries with potentially different privacy laws. We take steps to-->
<!--                  ensure adequate protection.</p>-->
<!--                <h4 class="tab_block-name">Changes to This Policy</h4>-->
<!--                <p class="tab_block-description">We may update this policy to reflect legal or operational changes. We-->
<!--                  will post the revised version and update the “Effective Date” above. We encourage you to review this-->
<!--                  page periodically.</p>-->
<!--                <h4 class="tab_block-name">Contact Us</h4>-->
<!--                <p class="tab_block-description">For questions, access requests, or to make a complaint, email us at: <br> <br>-->
<!--                  privacy@shoncompany.com-->
<!--                </p>-->
<!--              </div>-->

            </div>
          </div>

        </div>

      </section>
    </div>
    <Footer />
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
export default {
  name: "CookiePolicy",
  components: {
    Footer,
    NavBar,
  },
  data() {
    return {

    }
  }
}
</script>

<style scoped lang="scss">
.main {
  &_section {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 90px 0;
    @media screen and (max-width: 1680px) {
      padding: 60px 0 30px;
    }
    @media screen and (max-width: 1024px) {
      padding: 40px 0 20px;
    }

    &-title {
      color: #000;
      text-align: center;
      font-size: 48px;
      font-style: normal;
      font-weight: 900;
      line-height: normal;
      padding: 80px 0 40px;
      @media screen and (max-width: 1680px) {
        font-size: 32px;
      }
      @media screen and (max-width: 1024px) {
        font-size: 28px;
      }
      @media screen and (max-width: 540px) {
        font-size: 24px;
      }
    }

    &-sub {
      color: #181A2A;
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px; /* 150% */
    }

    &.cookie {
      & .questions {
        &_content {
          width: 85%;
          display: flex;
          flex-direction: column;
          align-items: center;
          @media screen and (max-width: 1440px) {
            width: 80%;
          }
          @media screen and (max-width: 540px) {
            width: 95%;
          }

          & .nav {
            &-pills {
            }

            &-item {
            }

            &-link {
              background: transparent;
              color: #1E1E1E;
              text-align: center;
              font-size: 36px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
              border-radius: 0;

              &.active {
                font-weight: 900;
                border-bottom: 4px solid #068BD6;
              }

              @media screen and (max-width: 540px) {
                font-size: 22px;
              }
            }
          }

          & .tab {
            &-pane {
              display: none;

              &.active {
                display: flex;
              }
              @media screen and (max-width: 440px) {
                flex-direction: column;
              }
            }

            &_block {
              padding: 60px 50px 10px;
              max-width: 780px;
              @media screen and (max-width: 1680px) {
                padding: 40px 35px 10px;
              }
              @media screen and (max-width: 1440px) {
                padding: 30px 20px 10px;
                max-width: 560px;
              }
              @media screen and (max-width: 540px) {
                padding: 20px 10px 0;
              }

              &-name {
                color: #000;
                font-size: 24px;
                font-weight: 700;
                line-height: 32px;
                padding-bottom: 18px;
                text-align: center;
                @media screen and (max-width: 1680px) {
                  font-size: 22px;
                }
                @media screen and (max-width: 1440px) {
                  font-size: 20px;
                  padding-bottom: 10px;
                }
                @media screen and (max-width: 540px) {
                  font-size: 17px;
                }
              }

              &-description {
                color: #181A2A;
                font-size: 16px;
                font-weight: 500;
                line-height: 24px;
                padding-bottom: 40px;
                @media screen and (max-width: 1680px) {
                  font-size: 18px;
                }
                @media screen and (max-width: 1440px) {
                  font-size: 16px;
                  padding-bottom: 50px;
                }
                @media screen and (max-width: 540px) {
                  font-size: 16px;
                  padding-bottom: 30px;
                }

                & ul {
                  margin-bottom: 5px;
                  padding: 10px 15px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
